import { Inject, Injectable } from '@angular/core';
import { ReportsService } from './reports.service.abstract';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReportsServiceImpl implements ReportsService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    /**
     * @param startDate date in YYYY-MM-DD format. If none is provided, will use the beginning of the current day as startDate
     * @param endDate date in YYYY-MM-DD format. If none is provided, will use the end of the current day as endDate
     * @returns Receipts[]
     */
    getReceipts(startDate: Date, endDate: Date): Observable<any> {
        let queryParams = new URLSearchParams();
        if (startDate) {
            queryParams.append('startDate', startDate.toISOString().split('T')[0]);
        }
        if (endDate) {
            queryParams.append('endDate', endDate.toISOString().split('T')[0]);
        }

        return this.http.get(`${this.baseUrl}/organisations/admin/reports/receipts?${queryParams.toString()}`);
    }

    /**
     * @param startDate date in YYYY-MM-DD format. If none is provided, will use the beginning of the current day as startDate
     * @param endDate date in YYYY-MM-DD format. If none is provided, will use the end of the current day as endDate
     * @returns Receipts[]
     */
    getReceiptsCSV(startDate: Date, endDate: Date): Observable<any> {
        let queryParams = new URLSearchParams();
        if (startDate) {
            queryParams.append('startDate', startDate.toISOString().split('T')[0]);
        }
        if (endDate) {
            queryParams.append('endDate', endDate.toISOString().split('T')[0]);
        }

        return this.http.get(`${this.baseUrl}/organisations/admin/reports/receipts/csv?${queryParams}`);
    }
}

export const REPORTS_SERVICE_PROVIDER_IMPL = {
    provide: ReportsService,
    useClass: ReportsServiceImpl,
};
